// extracted by mini-css-extract-plugin
export default {"column":"MFHfER_RBWqPYASmMOUJ","headerContainer":"tVLqncyUCwtuty3pkDQA","columnContent":"_tF9FNlt2h1VhYF4zFbu","noContent":"RwCHh9bpV3TbS9p9Zhvv"};